@if (hasDigitalInfoPackage(occupationalProfile)) {
<section class="o-wrapper" id="digitaal-infopakket" >
  <div class="c-digitaal-infopakket">
	<div class="c-digitaal-infopakket__image-box">
	  <img class="c-digitaal-infopakket__image" src="/cdn/img/beroepenfiche/digitaal-infopakket.svg" alt="">
	</div>
	<div class="c-digitaal-infopakket__content">
	  <h3>Is het beroep van {{occupationalProfile.title?.nl}} iets voor mij?</h3>
	  <p id="occupational-profile-info-package-description">Ontdek wat het beroep van {{occupationalProfile.title?.nl}} inhoudt. Wat het wel en wat het niet is. En of je ervoor geschikt bent.</p>
	  <a [href]="getDigitalInfoPackageUrl(occupationalProfile)" target="_self" class="action-book-open c-btn -light -small">Ga op verkenning</a>
	</div>
  </div>
</section>
}
